import React from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import revolution1 from "../assests/Images/RevolutionizingSales_Project1.jpg";
import revolution2 from "../assests/Images/RevolutionizingSales_Project2.jpg";
import { LuNewspaper } from "react-icons/lu";
import orsac from "../assests/Images/ORSAC_Project.jpg";
import redefining_project2 from "../assests/Images/Redefining_Project2.jpg";
import { Link } from "react-router-dom";
import WaveEffect from "../Components/WaveEffect";

const RevolutionizingSalesProject = () => {
  return (
    <div>
      <Navbar />
      <div
        className="bg-cover bg-center h-[50vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] sm:rounded-tl-[390px] xl:rounded-tl-[530px]"
        style={{ backgroundImage: `url(${revolution2})` }}
      >
        <div className="h-full bg-black bg-opacity-80 w-full flex flex-col justify-center items-center sm:rounded-tl-[390px] xl:rounded-tl-[530px]">
          <WaveEffect
            text="Revolutionizing Sales Operations"
            textClassName="text-white text-xl lg:text-5xl xl:text-5xl 2xl:text-3xl sm:text-3xl 2xl:text-5xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-4 w-24 bg-white" />
        </div>
      </div>

      <div className="m-10 xl:m-28 lg:m-20 md:m-16 sm:m-10 flex flex-col xl:flex-row lg:flex-row md:flex-col sm:flex-col gap-20 h-full sm:mt-10 ">
        <div className="w-full">
          <img
            src={revolution1}
            alt=""
            className="lg:h-[35rem]  md:h-[25rem] sm:h-[25rem] h-[20rem] w-full rounded-xl object-cover"
          />
        </div>

        <div className="flex justify-center">
          <div className="w-[35rem] h-fit shadow-lg p-10 md:w-[25rem]  sm:w-[20rem]  place-items-center ">
            <div className="flex flex-row gap-2 justify-start items-center border-b-2 border-gray-300">
              <LuNewspaper className="text-2xl text-primary" />
              <h1 className="text-2xl font-bold pb-4 text-center">
                Recent Case Studies
              </h1>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={orsac}
                alt=""
                className=" h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">April 3, 2025</h1>
                <Link to="/orsac-project" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">GIS & Remote Sensing Applications</h1>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={revolution2}
                alt=""
                className=" h-16 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link to="/redefining-productivity-incentives" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">
                    Redefining Productivity Incentives
                  </h1>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 py-5">
              <img
                src={redefining_project2}
                alt=""
                className="h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link to="/revolutionizing-sales-operations" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">
                    Revolutionizing Sales Operations
                  </h1>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center text-start gap-10 lg:px-28 p-10 text-lg mb-20">
        <p>
          <span className="font-semibold text-primary">The Game:</span>UltraTech
          Cement, a dominant force in the cement industry, was facing a hidden
          adversary—operational inefficiencies within its sales and support
          teams. These inefficiencies were creating a disconnect between the
          teams’ efforts and the rapidly evolving market demands. The ripple
          effects were clear: stagnant sales growth, reduced productivity, and a
          demotivated workforce struggling to keep up.
        </p>
        <p>
          <span className="font-semibold text-primary">The Solution: </span>{" "}
          Armed with this data, we redefined the Key Result Areas (KRAs) and Key
          Performance Metrics (KPMs) to better align with market realities. We
          didn’t just tweak the system; we built a new, digitally integrated
          approach to planning and coordination. Real-time monitoring tools were
          introduced to keep the teams agile and responsive, ensuring that every
          move was strategically aligned with the company’s goals.
        </p>
        <p>
          <span className="font-semibold text-primary">The Outcome:</span> The
          impact was profound. UltraTech’s sales force was not just
          restructured—they were revitalized. Sales targets were exceeded as the
          teams operated with newfound efficiency and purpose. The morale boost
          was palpable, as employees saw the direct results of their efforts.
          UltraTech Cement emerged stronger, with a sales force that was now a
          well-oiled machine, ready to drive growth and maintain their market
          leadership. This transformation wasn’t just about meeting targets; it
          was about setting a new standard for excellence in the industry.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default RevolutionizingSalesProject;
